import {HTTP} from "@/helpers/http-common"

const urlModule = 'comercio/sucursal'

const get = (sucursal) => new Promise((resolve,reject)=>{
  const {clave} = sucursal;
  HTTP.get(
    `/api/${urlModule}/${clave}`
  ).then(response=>{
    resolve(response);
  }).catch(error => {
    reject(error);
  });

});

const save = (sucursal) =>new Promise((resolve,reject)=>{
  const {clave, name, email
    , status
    , locationAddress
    , locationCity
    , locationRegionCode
    , locationCountryCode
    , locationPostalCode
    , consecutivoArchivosGenerados
    , numeroComercio
    , comercio
    , nombreArchivoCartRefresh
    , nombreArchivoCartRefreshCarga
    , mcc
  } = sucursal;
  HTTP
  .post(
    `/api/${urlModule}`
    , {clave, name, email
      , status
      , locationAddress
      , locationCity
      , locationRegionCode
      , locationCountryCode
      , locationPostalCode
      , consecutivoArchivosGenerados
      , numeroComercio
      , comercio
      , nombreArchivoCartRefresh
      , nombreArchivoCartRefreshCarga
      , mcc
    }
  ).then(response=>{
    // console.log(response)
    resolve(response);
  }).catch(error=>{
    reject(error.response);
  });
});

const update = (sucursal) =>new Promise((resolve,reject)=>{
  const {clave, name, email
    , status
    , locationAddress
    , locationCity
    , locationRegionCode
    , locationCountryCode
    , locationPostalCode
    , consecutivoArchivosGenerados
    , numeroComercio
    , comercio
    , nombreArchivoCartRefresh
    , nombreArchivoCartRefreshCarga
    , mcc
  } = sucursal;
  HTTP
  .put(
    `/api/${urlModule}`
    , {clave, name, email
      , status
      , locationAddress
      , locationCity
      , locationRegionCode
      , locationCountryCode
      , locationPostalCode
      , consecutivoArchivosGenerados
      , numeroComercio
      , comercio
      , nombreArchivoCartRefresh
      , nombreArchivoCartRefreshCarga
      , mcc
    }
  ).then(response=>{
    resolve(response);
  }).catch(error=>{
    reject(error.response);
  });
});

const disable = (comercio) =>new Promise((resolve,reject)=>{
  const {clave} = comercio;
  HTTP
  .delete(
    `/api/${urlModule}`
    , {
      params:{clave}
    }
  ).then(response=>{
    resolve(response);
  }).catch(error=>{
    reject(error.response);
  });
});

const list = (comercio) =>new Promise((resolve,reject)=>{
  HTTP
  .post(
    `/api/${urlModule}/list`
    , {comercio
    }
  ).then(response=>{
    // console.log(response)
    resolve(response);
  }).catch(error=>{
    reject(error.response);
  });
});



//Export methods
export default{
  get
  , save
  , update
  , disable
  , list
}



// WEBPACK FOOTER //
// ./src/services/generales/sucursal/index.js